import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-initial-active-inactive-pathology-miah-crohn',
    templateUrl: './bar-chart-stable-unstable-initial-active-inactive-pathology-miah-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-initial-active-inactive-pathology-miah-crohn.component.css']
})

export class BarChartStableUnstableInitialActiveInactivePathologyMiahCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  attivitaLieve = [];
  attivitaModerata = [];
  attivitaGrave = [];
  // other arrays
  stabiliLieveInactive = 0;
  stabiliModerataInactive = 0;
  stabiliGraveInactive = 0;
  stabiliRemissioneInactive = 0;
  instabiliMiglLieveInactive = 0;
  instabiliMiglModerataInactive = 0;
  instabiliMiglGraveInactive = 0;
  instabiliPegLieveInactive = 0;
  instabiliPegModerataInactive = 0;
  instabiliPegGraveInactive = 0;
  instabiliMiglRemissioneInactive = 0;
  instabiliPegRemissioneInactive = 0;
  
  stabiliLieveActive = 0;
  stabiliModerataActive = 0;
  stabiliGraveActive = 0;
  stabiliRemissioneActive = 0;
  instabiliMiglLieveActive = 0;
  instabiliMiglModerataActive = 0;
  instabiliMiglGraveActive = 0;
  instabiliPegLieveActive = 0;
  instabiliPegModerataActive = 0;
  instabiliPegGraveActive = 0;
  instabiliMiglRemissioneActive = 0;
  instabiliPegRemissioneActive = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableMiahCrohnInitialActiveInactivePathology: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['MALATTIA INIZIALE INATTIVA-STABILI','MALATTIA INIZIALE INATTIVA-IN MIGLIORAMENTO','MALATTIA INIZIALE INATTIVA-IN PEGGIORAMENTO',
  'MALATTIA INIZIALE ATTIVA-STABILI','MALATTIA INIZIALE ATTIVA-IN MIGLIORAMENTO','MALATTIA INIZIALE ATTIVA-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 20,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 20,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 20,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 20,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveInitialActiveInactivePathologyStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveInitialActiveInactivePathologyStableAndUnstable(){
    this.subscription = this.doctorService.getMiahCrohnStableAndUnstableInitialActiveInactivePathology().subscribe( data => {
      let keys = Object.keys(data);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        if (key === 'StabiliRemissioneInattiva'){
          this.stabiliRemissioneInactive = values[i];
        }
        else if (key === 'InstabiliMiglLieveAttiva'){
          this.instabiliMiglLieveActive = values[i];
        }
        else if (key === 'InstabiliMiglModerataAttiva'){
          this.instabiliMiglModerataActive = values[i];
        }
        else if (key === 'InstabiliMiglGraveAttiva'){
            this.instabiliMiglGraveActive = values[i];
        }
        else if (key === 'StabiliRemissioneAttiva'){
          this.stabiliRemissioneActive = values[i];
        }
        else if (key === 'InstabiliPegLieveAttiva'){
          this.instabiliPegLieveActive = values[i];
        }
        else if (key === 'InstabiliPegModerataAttiva'){
            this.instabiliPegModerataActive = values[i];
        }
        else if (key === 'InstabiliPegGraveAttiva'){
            this.instabiliPegGraveActive = values[i];
        }
        else if (key === 'InstabiliPegRemissioneAttiva'){
          this.instabiliPegRemissioneActive = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneAttiva'){
          this.instabiliMiglRemissioneActive = values[i];
        }
        else if (key === 'InstabiliPegRemissioneInattiva'){
          this.instabiliPegRemissioneInactive = values[i];
        }
        else if (key === 'InstabiliPegLieveInattiva'){
          this.instabiliPegLieveInactive = values[i];
        }
        else if (key === 'InstabiliPegModerataInattiva'){
            this.instabiliPegModerataInactive = values[i];
        }
        else if (key === 'InstabiliPegGraveInattiva'){
            this.instabiliPegGraveInactive = values[i];
        }
        else if (key === 'StabiliLieveInattiva'){
          this.stabiliLieveInactive = values[i];
        }
        else if (key === 'StabiliModerataInattiva'){
            this.stabiliModerataInactive = values[i];
        }
        else if (key === 'StabiliGraveInattiva'){
            this.stabiliGraveInactive = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneInattiva'){
          this.instabiliMiglRemissioneInactive = values[i];
        }
        else if (key === 'StabiliLieveAttiva'){
          this.stabiliLieveActive = values[i];
        }
        else if (key === 'StabiliModerataAttiva'){
            this.stabiliModerataActive = values[i];
        }
        else if (key === 'StabiliGraveAttiva'){
            this.stabiliGraveActive = values[i];
        }
        else if (key === 'InstabiliMiglLieveInattiva'){
          this.instabiliMiglLieveInactive = values[i];
        }
        else if (key === 'InstabiliMiglModerataInattiva'){
            this.instabiliMiglModerataInactive = values[i];
        }
        else if (key === 'InstabiliMiglGraveInattiva'){
            this.instabiliMiglGraveInactive = values[i];
        }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGraveInactive);
      this.attivitaGrave.push(this.instabiliMiglGraveInactive);
      this.attivitaGrave.push(this.instabiliPegGraveInactive);
      this.attivitaGrave.push(this.stabiliGraveActive);
      this.attivitaGrave.push(this.instabiliMiglGraveActive);
      this.attivitaGrave.push(this.instabiliPegGraveActive);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieveInactive);
      this.attivitaLieve.push(this.instabiliMiglLieveInactive);
      this.attivitaLieve.push(this.instabiliPegLieveInactive);
      this.attivitaLieve.push(this.stabiliLieveActive);
      this.attivitaLieve.push(this.instabiliMiglLieveActive);
      this.attivitaLieve.push(this.instabiliPegLieveActive);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerataInactive);
      this.attivitaModerata.push(this.instabiliMiglModerataInactive);
      this.attivitaModerata.push(this.instabiliPegModerataInactive);
      this.attivitaModerata.push(this.stabiliModerataActive);
      this.attivitaModerata.push(this.instabiliMiglModerataActive);
      this.attivitaModerata.push(this.instabiliPegModerataActive);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissioneInactive);
      this.remissione.push(this.instabiliMiglRemissioneInactive);
      this.remissione.push(this.instabiliPegRemissioneInactive);
      this.remissione.push(this.stabiliRemissioneActive);
      this.remissione.push(this.instabiliMiglRemissioneActive);
      this.remissione.push(this.instabiliPegRemissioneActive);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableMiahCrohnInitialActiveInactivePathology') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableMiahCrohnInitialActiveInactivePathology.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}